import styled from 'styled-components';
import {Col} from 'reactstrap';

export const Column = styled(Col)`
  margin-bottom: 1rem;
`